var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-disk-1{fill:#4285f4;}.cls-disk-2{fill:#aecbfa;}.cls-disk-3{fill:#669df6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_PersistentDisk_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-disk-1",
    points: "16.17 13.67 16.17 18.25 4.08 18.25 4.08 22 19.92 22 19.92 13.67 16.17 13.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-disk-2",
    points: "7.83 10.33 7.83 5.75 19.92 5.75 19.92 2 4.08 2 4.08 10.33 7.83 10.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-disk-3",
    points: "9.92 7.83 9.92 12.42 4.08 12.42 4.08 16.17 14.08 16.17 14.08 11.58 19.92 11.58 19.92 7.83 9.92 7.83"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisk);
export default __webpack_public_path__ + "static/media/disk.959eaa4f858a39c8467a3909945c75de.svg";
export { ForwardRef as ReactComponent };